<script>
	export let label = 'Next'
	export let clickEvent
	export let alternate = true
	export let disabled = false
	export let narrow = false
	export let link = false;

	const buttonClasses = () => {
		let classes = ''
		if (alternate){
			classes += 'is-alt'
		}
		if (narrow){
			classes += ' is-narrow'
		}
		return classes
	}

	if (link){
		clickEvent = () => window.open(link);
	}

</script>

<button disabled="{disabled}" 
				class="{ buttonClasses() }" 
				on:click={clickEvent}
>
	<slot>{label}</slot>
</button>

<style lang="scss">
@import '../scss/variables.scss';
button {
	margin-top: 40px;
	border-radius: 30px;
	min-width: 150px;
	padding: 12px 20px;
	text-align: center;
	background-color: #2375bf;
	color: white;
	font-size: 18px;
	display: flex;
	font-weight: 600;
	justify-content: center;
	align-items: center;
	border: none;
	width: 100%;
	cursor: pointer;
	&.is-alt{
		background-color: #101D32;
		margin-top: 0;
		font-size: 16px;
		font-weight: 600;
	}
	&.is-narrow {
		width: auto;
	}
}

button:disabled,
button[disabled] {
	background-color: $light-grey;
	cursor:default;
}
@include mobile {
	button.is-narrow:not(.is-alt) {
		width: 100%
	}
}
</style>